export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },

  {
    title: 'Users',
    route: 'users',
    icon: 'UserIcon',
  },

  {
    title: 'Meetings',
    icon: 'VideoIcon',
    children: [
      {
        title: 'Add Meeting',
        route: 'addmeeting',
        icon: 'PlusSquareIcon',
      },
      {
        title: 'Meetings',
        route: 'meetings',
        icon: 'VideoIcon',
      },
    ],
  },

  {
    title: 'Payments',
    icon: 'DollarSignIcon',
    children: [
      {
        title: 'Add Payment',
        route: 'addpayment',
        icon: 'PlusIcon',
      },
      {
        title: 'Payments',
        route: 'allpayments',
        icon: 'DollarSignIcon',
      },
      {
        title: 'Payments Date Range',
        route: 'paymentsdaterange',
        icon: 'DollarSignIcon',
      },
      {
        title: 'Payment Due List',
        route: 'paymentduelist',
        icon: 'ListIcon',
      },
    ],
  },

  {
    title: 'Attendences',
    route: 'attendences',
    icon: 'UserIcon',
  },

  {
    title: 'Lms Management',

    icon: 'FileIcon',
    children: [

      {
        title: 'Add LMS Drive Link',
        route: 'addlmsfiles',
        icon: 'PlusSquareIcon',
      },

      {
        title: 'LMS Drive Links',
        route: 'lmsLinks',
        icon: 'FileIcon',
      },

    ],

  },
]
